/**
 * The page the Install and Verify screens check: one of the site's websites
 * plus a path. Remembered per site in this browser, so a path typed on
 * Verify is the page Install's CSP check reads too.
 */
import { useLocalState } from '../ui/hooks';

export function pageUrl(origin: string, path: string): string {
  const p = path.trim() || '/';
  return `${origin.replace(/\/+$/, '')}${p.startsWith('/') ? p : `/${p}`}`;
}

/** `origin + pathname` of a URL, for matching a recorded check to the chosen page. */
export function samePage(a: string, b: string): boolean {
  try {
    const x = new URL(a);
    const y = new URL(b);
    return x.origin === y.origin && x.pathname === y.pathname;
  } catch {
    return false;
  }
}

export function sameOrigin(a: string, origin: string): boolean {
  try {
    return new URL(a).origin === new URL(origin).origin;
  } catch {
    return false;
  }
}

export function useCheckTarget(siteKey: string, origins: string[]) {
  const [saved, setOrigin] = useLocalState(`fx-check-origin-${siteKey}`, '');
  const [path, setPath] = useLocalState(`fx-check-path-${siteKey}`, '/');
  const origin = origins.includes(saved) ? saved : (origins[0] ?? '');
  return { origin, setOrigin, path, setPath, url: origin ? pageUrl(origin, path) : '' };
}
